/* eslint-disable import/no-restricted-paths */
import * as React from 'react';

import { IFlatPriceInfoSchema } from '../../repositories/special-promos/entities/entities/FlatPriceInfoSchema';
import { IJkSchema } from '../../repositories/special-promos/entities/entities/JkSchema';
import { IMapSettingsSchema } from '../../repositories/special-promos/entities/entities/MapSettingsSchema';
import { IGetImageSchema } from '../../repositories/special-promos/entities/schemas/GetImageSchema';

import { YmapsApi } from '../../../browser/ymaps/ymaps-api';
import { JkList } from '../jk-list';
import { IJkMapData, Map } from '../map';
import { Tabs } from './tabs';

import * as styles from './index.css';

export type TabId = 'map' | 'tiles';

interface IJkSectionState {
  activeTab: TabId;
}

interface IJkSectionProps {
  jks: IJkSchema[];
  builderNameGenitive: string;
  mainColor: string;
  mapSettingsJk: IMapSettingsSchema;
  pinImage: IGetImageSchema;
  ymaps?: YmapsApi;
}

const getMinPrice = (flatInfoList: IFlatPriceInfoSchema[]) => {
  const minPrices: number[] = [];
  flatInfoList.forEach(flatInfo => !!flatInfo.minPrice && minPrices.push(flatInfo.minPrice));

  return Math.min(...minPrices);
};

const formatJkToJkMapData = (jk: IJkSchema): IJkMapData => ({
  address: jk.address ?? '',
  buildingStatusInfo: jk.buildingStatusInfo ?? '',
  coordinates: { lat: jk.coordinates?.lng ?? 0, lng: jk.coordinates?.lat ?? 0 }, // В базе координаты ЖК перепутаны
  imageUrl: jk.image?.url ?? '',
  minPrice: getMinPrice(jk.flatInfoList ?? []),
  name: jk.name,
  url: jk.fullUrl ?? '',
});

export class JkSection extends React.PureComponent<IJkSectionProps, IJkSectionState> {
  public constructor(props: IJkSectionProps) {
    super(props);

    this.state = {
      activeTab: 'tiles',
    };
  }

  public render() {
    const { activeTab } = this.state;
    const { jks, builderNameGenitive, mapSettingsJk, mainColor, ymaps, pinImage } = this.props;

    return (
      <div>
        <div className={styles['head']}>
          <h3 className={styles['title']}>Квартиры в новостройках от {builderNameGenitive}</h3>
          <Tabs onToggle={(tab: TabId) => this.setState({ activeTab: tab })} tab={activeTab} />
        </div>
        <div className={styles['tab-content']}>
          {activeTab === 'tiles' ? (
            <JkList jks={jks} />
          ) : (
            <Map
              initialCenter={[mapSettingsJk.lat, mapSettingsJk.lng]}
              initialZoom={mapSettingsJk.zoom}
              mainColor={mainColor}
              mapId="jk-map"
              ymaps={ymaps}
              pinImageUrl={pinImage && pinImage.url ? pinImage.url : undefined}
              pins={jks.map(formatJkToJkMapData)}
            />
          )}
        </div>
      </div>
    );
  }
}
